import { useGetGenreTreeSuspense } from "@/orval/gen"
import { TreePillsInput } from "../tree/tree-pills-input"
import { useTranslation } from "react-i18next"
import { PillsInputProps } from "@mantine/core"

interface GenreTreeSelectProps extends Omit<
  PillsInputProps,
  "onChange" | "value"
> {
  value?: string[] | null | undefined
  onChange?: (value: string[]) => void
  placeholder?: React.ReactNode
}

export function GenreTreeSelect({
  value,
  onChange,
  ...props
}: GenreTreeSelectProps) {
  const { data: genreTree } = useGetGenreTreeSuspense()
  const { t } = useTranslation("app_server")
  const initialCheckedState =
    typeof value === "string" ? undefined : (value ?? [])
  return (
    <TreePillsInput
      initialCheckedState={initialCheckedState}
      tree={genreTree.tree}
      label={t("Genres")}
      onCheckedStateChange={onChange}
      {...props}
    />
  )
}
